import { GlLoadingIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { RichViewer, SimpleViewer } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/blob/components/blob_viewers/index.js?vue3';
import BlobContentError from '/builds/gitlab/gitlab-ee/app/assets/javascripts/blob/components/blob_content_error.vue?vue3';
import { BLOB_RENDER_EVENT_LOAD, BLOB_RENDER_EVENT_SHOW_SOURCE, RICH_BLOB_VIEWER } from './constants';
export default {
    name: 'BlobContent',
    components: {
        GlLoadingIcon,
        BlobContentError
    },
    props: {
        blob: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        projectPath: {
            type: String,
            required: false,
            default: ''
        },
        currentRef: {
            type: String,
            required: false,
            default: ''
        },
        content: {
            type: String,
            default: '',
            required: false
        },
        shouldPreloadBlame: {
            type: Boolean,
            required: false,
            default: false
        },
        showBlame: {
            type: Boolean,
            required: false,
            default: false
        },
        isRawContent: {
            type: Boolean,
            default: false,
            required: false
        },
        richViewer: {
            type: String,
            default: '',
            required: false
        },
        loading: {
            type: Boolean,
            default: true,
            required: false
        },
        activeViewer: {
            type: Object,
            required: true
        },
        isBlameLinkHidden: {
            type: Boolean,
            required: false,
            default: false
        },
        hideLineNumbers: {
            type: Boolean,
            required: false,
            default: false
        },
        isSnippet: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        BLOB_RENDER_EVENT_LOAD,
        BLOB_RENDER_EVENT_SHOW_SOURCE
    ],
    data () {
        return {
            richContentLoaded: false
        };
    },
    computed: {
        viewer () {
            switch(this.activeViewer.type){
                case 'rich':
                    return RichViewer;
                default:
                    return SimpleViewer;
            }
        },
        viewerError () {
            return this.activeViewer.renderError;
        },
        lineNumbers () {
            // rawTextBlob is used for source code files and content for snippets
            const content = this.blob?.rawTextBlob || this.content;
            return content?.split('\n')?.length || 0;
        },
        isContentLoaded () {
            return this.activeViewer.type === RICH_BLOB_VIEWER ? !this.loading && this.richContentLoaded : !this.loading;
        }
    },
    BLOB_RENDER_EVENT_LOAD,
    BLOB_RENDER_EVENT_SHOW_SOURCE
};
